import { createAsyncThunk } from '@reduxjs/toolkit';
import { ApplicationDataApi } from 'api/ApplicationDataApi';

import { ErrorResponse } from './ErrorResponse';

export const createGetLoanBreakdownThunk = (api: ApplicationDataApi) =>
  createAsyncThunk('/loanManagement/progress', async (applicationId: string, thunkApi) => {
    try {
      return await api.getLoanBreakdown(applicationId);
    } catch (error: unknown) {
      return thunkApi.rejectWithValue((error as ErrorResponse).response.data);
    }
  });
